export default {
    carbonCredit: {
        view: 'Visualizar',
        edit: 'Editar',
        back: 'Voltar',
        preview: 'Pré-visualização',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        dashboard: 'Painel de Controle',
        select: 'Selecionar',
        submit: 'Enviar',
        save: 'Salvar',
        title: 'Crédito de Carbono',
        projects: 'Projetos',
        carbonProjectCredits: 'Créditos de Projeto de Carbono',
        carbonCreditProjects: 'Projetos de Crédito de Carbono',
        exportAs: 'Exportar como',
        downloadAsCSV: 'Baixar como CSV',
        downloadAsExcel: 'Baixar como Excel',
        downloadAsPDF: 'Baixar como PDF',
        registerNewProject: 'Registrar Novo Projeto',
        creditInfo: '*Este é o número aproximado de créditos. O número real de créditos pode ser diferente após verificação.',
        search: 'Pesquisar',
        projectTitle: 'Título do Projeto',
        projectType: 'Tipo de Projeto',
        country: 'País',
        totalCreditsGenerated: 'Total de Créditos Gerados',
        status: 'Status',
        descriptionPlaceholder: "Por favor, forneça uma descrição do projeto incluindo objetivos",
        filePreviewNotAvailable: 'Pré-visualização do arquivo não está disponível para este tipo de arquivo',
        active: 'Ativo',
        inactive: 'Inativo',
        pending: 'Pendente',
        proposed: 'Proposto',
        planned: 'Planejado',
        inProgress: 'Em Andamento',
        operational: 'Operacional',
        deactivated: 'Desativado',
        avoidedDeforestation: 'Deforestação Evitada',
        agroForestry: 'Agrofloresta',
        forestry: 'Silvicultura',
        regenerativeAgriculture: 'Agricultura Regenerativa',
        agroforestry: 'Agrofloresta',
        regenerative_agriculture: 'Agricultura Regenerativa',
        projectDeletedSuccessfully: 'Projeto desativado com sucesso',
        projectUpdatedSuccessfully: 'Projeto atualizado com sucesso',
        projectRegisteredSuccessfully: 'Projeto registrado com sucesso',
        deactivateProjectError: 'Erro ao desativar projeto',
        deactivate: 'Desativar',
        deactivateProject: 'Desativar Projeto',
        deactivateConfirmation: 'Tem certeza de que deseja desativar este projeto?',
        registerProject: 'Registrar um Novo Projeto',
        editProject: 'Editar Projeto',

        register: { 
            title: 'Registrar um Projeto',
            editTitle: 'Editar Projeto',
            projectTitle: 'Título do Projeto',
            projectType: 'Tipo de Projeto',
            description: 'Descrição',
            selectCountry: "Selecionar País",
            selectOrganization: 'Selecionar Organizações',
            status: 'Status',
            creditType: 'Tipo de Crédito',
            creditStart: 'Início do Crédito',
            creditEnd: 'Fim do Crédito',
            standardMethodology: 'Padrão/Metodologia',
            validationDocumentation: 'Documentação de Validação',
            vintage: 'Safra',
            currency: 'Moeda',
            projectInfo: 'Informações do Projeto',
            organizationDetails: 'Detalhes das Organizações',
            attachmentTitle: 'Anexo(s)',
            attachmentInfo: 'Você pode adicionar qualquer documento adicional, imagens, vídeo e arquivos de áudio relevantes para o projeto',
            documentation: 'Documentação',
            sdgsTitle: 'Objetivos de Desenvolvimento Sustentável (ODS)',
            sdgsInfo: 'Por favor, selecione apenas os objetivos relevantes para este projeto específico. As organizações terão acesso para ver apenas os objetivos vinculados a este projeto.',
            dataCollectionTitle: 'Ciclo de Coleta de Dados',
            dataCollectionInfo: 'Para participar do Programa de Crédito de Carbono, os agricultores devem fornecer dados históricos da fazenda durante o cadastro e continuar enviando atualizações periódicas de dados enquanto o programa permanecer ativo. Isso garante o rastreamento preciso do desempenho do carbono ao longo do tempo.',
            vintageYear: 'Ano da Safra',
            estimatedCredit: 'Créditos Estimados',
            pricePerCredit: 'Preço Por Crédito',
            moduleName: 'Nome do Módulo',
            futureData: 'Coleta de Dados Recorrentes Futuros',
            score: 'Pontuação',
            approval: 'Aprovação',

            projectAgreement: 'Acordo do Projeto',
            headerImage: 'Imagem do Cabeçalho',
            headerImageInfo: '(Tamanho da imagem do cabeçalho 1920 x 420 pixels. A imagem padrão será substituída pela nova imagem que você enviar)',
            headerImagePlaceholder: "Imagem do Cabeçalho Padrão",
            responsibleDimitraOffice: 'Escritório Dimitra Responsável',
            selectDimitraOffice: 'Selecionar Escritório Dimitra',
            makeASelection: 'Fazer uma Seleção',
            addNewDimitraOffice: 'Adicionar Novo Escritório Dimitra',
            editDimitraOffice: 'Editar Escritório Dimitra',
            officeName: 'Nome do Escritório',
            contactPerson: 'Nome da Pessoa de Contato',
            phoneNumber: 'Número de Telefone',
            email: 'E-mail',
            address: 'Endereço',
            officeNameRequired: 'Nome do escritório é obrigatório',
            contactPersonRequired: 'Nome da pessoa de contato é obrigatório',
            addressRequired: 'Endereço é obrigatório',
            phoneNumberRequired: 'Número de telefone é obrigatório',
            phoneNumberInvalid: 'Número de telefone é inválido',
            phoneNumberLength: 'Número de telefone deve ter pelo menos 10 dígitos',
            selectVintage: 'Selecionar Safra',
            officeAddedSuccessfully: 'Escritório Dimitra adicionado com sucesso',
            errorAddingOffice: 'Erro ao adicionar escritório Dimitra',
            searchOrganizations: 'Pesquisar Organizações',
            searchOrganizationsPlaceholder: 'Pesquisar por nome da organização...',
            noOrganizationsFound: 'Nenhuma organização encontrada',
            loadingOrganizations: 'Carregando organizações...',
            selectedOrganizations: 'Organizações Selecionadas',
            errorNegative: 'não pode ser negativo.',
            errorRequiredField: '{field} é obrigatório.',
            errorOrganizationRequired: 'Pelo menos uma organização deve ser selecionada.',
            errorVintageRequired: 'Pelo menos uma entrada de safra é obrigatória.',
            errorVintageFieldsRequired: 'Todos os campos da safra (ano, créditos, preço) são obrigatórios.',
            allOrganizations: 'Todas as Organizações',
            removal: 'Remoção',
            avoided: 'Evitado',
            mandatory: 'Obrigatório',
            scoreValidationError: 'Pontuação inválida para o módulo "{module}". A pontuação deve ser um número inteiro 0 ou maior.',
            approvalValidationError: 'Aprovação inválida para o módulo "{module}". A aprovação deve ser um número inteiro entre 0 e 100.',
            saveError: 'Falha ao salvar projeto',
            fileUploadFailed: 'Falha no Upload do Arquivo',
            unsupportedFileFormat: 'Formato de arquivo não suportado',
            errorUploadingFile: 'Erro ao fazer upload do arquivo',
            scoreError: {
                invalid: 'A pontuação deve ser um número válido',
                range: 'A pontuação deve ser 0 ou maior',
                wholeNumber: 'A pontuação deve ser um número inteiro'
            },
            approvalError: {
                invalid: 'A aprovação deve ser um número válido',
                range: 'A aprovação deve estar entre 0 e 100',
                wholeNumber: 'A aprovação deve ser um número inteiro'
            },
            selectStatus: 'Selecionar Status',
            selectCreditType: 'Selecionar Tipo de Crédito',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Padrão',
            browse: 'Navegar',
            currencyPlaceholder: 'USD',
            selectFile: 'Selecionar Arquivo',
            dragDropFiles: 'Arraste e solte arquivos aqui',
            hideDetails: 'Ocultar Detalhes',
            viewDetails: 'Ver Detalhes',
            website: 'Site',
            month: 'Mês(es)',
            year: 'Ano(s)',
        },

        error: 'Erro',
        success: 'Sucesso',
        remove: 'Remover',

        projectInfo: {
            title: 'Informações do Projeto',
            organizationDetail: 'Detalhe da Organização',
            subOrganizations: 'Sub-organizações',
            search: 'Pesquisar',
            organizations: 'Organizações',
            users: 'Usuários',
            registrationDate: 'Data de Registro',
            close: 'Fechar',
            country: 'País',
            organizationsAddress: 'Endereço das Organizações',
            blockchainAddress: 'Endereço Blockchain',
            creditType: 'Tipo de Crédito',
            projectType: 'Tipo de Projeto',
            officeName: 'Nome do Escritório',
            contactPersonName: 'Nome da Pessoa de Contato',
            contactNumber: 'Número de Contato',
            email: 'E-mail',
            address: 'Endereço',
            website: 'Site',
            companyName: 'Nome da Empresa',
            companyAddress: 'Endereço da Empresa',
            web: 'Site',
            vintageYear: 'Ano da Safra',
            estimatedCredits: 'Créditos Estimados',
            pricePerCredit: 'Preço Por Crédito',
            module: 'Módulo',
            recurring: 'Recorrente',
            score: 'Pontuação',
            approval: 'Aprovação',
            responsibleDimitraOffice: 'Escritório Dimitra Responsável',
            status: 'Status',
            standardMethodology: 'Padrão/Metodologia',
            validationDocumentation: 'Documentação de Validação',
            creditStart: 'Início do Crédito',
            creditEnd: 'Fim do Crédito',
            attachmentTitle: 'Anexo(s)',
            sdgsTitle: 'Objetivos de Desenvolvimento Sustentável (ODS)',
            dataCollectionTitle: 'Ciclo de Coleta de Dados',
            dataCollectionInfo: 'Para participar do Programa de Crédito de Carbono, os agricultores devem fornecer dados históricos da fazenda durante o cadastro e continuar enviando atualizações periódicas de dados enquanto o programa permanecer ativo. Isso garante o rastreamento preciso do desempenho do carbono ao longo do tempo.',
            vintage: 'Safra',
            moduleName: 'Nome do Módulo',
            futureData: 'Coleta de Dados Recorrentes Futuros',
            estimatedCredit: 'Créditos Estimados',
        },

        user: {
            title: 'Usuário(s) de Crédito de Carbono',
            selectOrganization: 'Selecionar Organização',
            selectProject: 'Selecionar Projeto',
            allUsers: 'Todos os Usuários',
            activeUsers: 'Usuários Ativos',
            deactivatedUsers: 'Usuários Desativados',
            pendingUsers: 'Usuários Pendentes',
            search: 'Pesquisar',
            farmerName: 'Nome do Agricultor',
            farmName: 'Nome da Fazenda',
            organizations: 'Organizações',
            country: 'País',
            projectTitle: 'Título do Projeto',
            registerProject: 'Registrar um Novo Projeto',
            actions: 'Ações',
            noData: 'Nenhum usuário encontrado.',
            view: 'Visualizar',
            viewLandPermit: 'Ver Título de Propriedade / Permissão',
            edit: 'Editar',
            deactivate: 'Desativar',
            deactivateUser: 'Desativar Usuário',
            deactivateConfirmation: 'Tem certeza de que deseja desativar este usuário?',
            activate: 'Ativar',
            activateUser: 'Ativar Usuário',
            activateConfirmation: 'Tem certeza de que deseja ativar este usuário?',
            deactivatedSuccessfully: 'Usuário desativado com sucesso',
            activatedSuccessfully: 'Usuário ativado com sucesso',
            deactivationFailed: 'Erro ao desativar usuário',
            exportAsPdf: 'Exportar como PDF',
            projectDetails: 'Detalhes do Projeto',
            dateJoined: 'Data de Adesão',
            cropGrowingPractice: 'Prática de Cultivo',
            farm: 'Fazenda',
            rejectAll: 'REJEITAR TUDO',
            acceptAll: 'ACEITAR TUDO',
            confirmRejectAll: 'Você está prestes a rejeitar solicitações para todas as fazendas se juntarem ao projeto de crédito de carbono. Esta ação excluirá todas as fazendas enviadas pelo agricultor nesta solicitação. Tem certeza de que deseja continuar?',
            confirmAcceptAll: 'Você está prestes a aceitar solicitações para todas as fazendas se juntarem ao projeto de crédito de carbono. Esta ação incluirá todas as fazendas enviadas pelo agricultor nesta solicitação. Tem certeza de que deseja continuar?',
            dateOfRegistration: 'Data de Registro',
            farmRegistrationId: 'ID de Registro da Fazenda',
            dimitraFarmId: 'ID da Fazenda Dimitra',
            notTheFarmer: "Eu não sou o Agricultor",
            farmerFirstName: 'Primeiro Nome do Agricultor',
            farmerMiddleName: 'Nome do Meio do Agricultor',
            farmerLastName: 'Sobrenome do Agricultor',
            farmerRegistrationId: 'ID de Registro do Agricultor',
            dimitraFarmerId: 'ID do Agricultor Dimitra',
            farmGeofence: 'Geocerca da Fazenda',
            viewGeofence: 'Ver Geocerca',
            totalFarmSize: 'Tamanho Total da Fazenda',
            mainGoals: 'Quais são Seus Objetivos Principais',
            ownershipType: 'Tipo de Propriedade',
            certifications: 'Certificação(ões)',
            productionType: 'Tipo de Produção',
            landTitle: 'Título de Propriedade',
            farmLocationAddress: 'Endereço de Localização da Fazenda',
            farmCoordinate: 'Coordenada da Fazenda',
            farmerAgreement: 'Acordo do Agricultor',
            viewSignedAgreement: 'Ver acordo assinado enviado com a solicitação.',
            viewAgreement: 'VER ACORDO',
            acceptanceStatus: 'Status de Aceitação',
            currentStatus: 'Status Atual',
            reject: 'REJEITAR',
            accept: 'ACEITAR',
            farmActivitySubmissions: 'Submissões de Atividade da Fazenda',
            farmActivitySubmissionsDesc: 'Registros enviados de práticas agrícolas e atualizações necessárias para verificação de crédito de carbono.',
            viewFarmData: 'VER DADOS DA FAZENDA',
            farmData: 'Dados da Fazenda',
            farmDataDesc: 'Crie seus relatórios integrando dados de produção de várias fontes. Selecione uma ou múltiplas fontes para compilar uma lista completa de locais de produção para seus relatórios.',
            crops: 'Culturas',
            sowing: 'Semeadura',
            seedling: 'Muda',
            fertilizer: 'Fertilizante',
            fertilizerError: 'Submissão incompleta: Informações de fertilizante para 4 meses estão faltando na entrada do agricultor.',
            harvesting: 'Colheita',
            livestock: 'Gado',
            equipment: 'Equipamento',
            projectRequests: 'Solicitações de Projeto',
            userNameAndId: 'Nome de Usuário e ID',
            email: 'E-mail',
            userRole: 'Perfil de Usuário',
            status: 'Status',
            userRegistrationDate: 'Data de Registro de Usuário',
            pending: 'Pendente',
            deactivated: 'Desativado',
            active: 'Ativo',
            selectProjectTypeFirst: 'Selecione o Tipo de Projeto Primeiro',
            noFarmsToReject: 'Nenhuma fazenda para rejeitar',
            allFarmsRejected: 'Todas as fazendas rejeitadas com sucesso',
            rejectAllError: 'Falha ao rejeitar todas as fazendas',
            noFarmsToAccept: 'Nenhuma fazenda para aceitar',
            allFarmsAccepted: 'Todas as fazendas aceitas com sucesso',
            acceptAllError: 'Falha ao aceitar todas as fazendas',
            farmNotFound: 'Fazenda não encontrada ou não associada ao projeto',
            farmAlreadyRejected: 'A fazenda já foi rejeitada',
            farmRejected: 'Fazenda rejeitada com sucesso',
            rejectFarmError: 'Falha ao rejeitar a fazenda',
            farmAlreadyAccepted: 'A fazenda já foi aceita',
            farmAccepted: 'Fazenda aceita com sucesso',
            acceptFarmError: 'Falha ao aceitar a fazenda',
        },
    }
} 